import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  selectedFile: File;
  passwordError: string;
  err: any;

  constructor(private authService: AuthService, private router: Router) { }
  ngOnInit() {
  }

  processFile(imageInput: any) {
    this.selectedFile = imageInput.files[0];
    //console.log(this.selectedFile, imageInput);
  }

  register(val){
    val.value.profile_picture = this.selectedFile;
    //console.log(val.value);
    if(val.valid){
      if(val.value.password == val.value.confirm_password){
        this.authService.postUser(val.value).subscribe(
          (res)=>{
            if(res){
              //console.log("User data posted");
              this.authService.logIn(res).subscribe(
                (respond)=>{
                  if(respond){
                    this.router.navigateByUrl('/userdash');
                  }
                }
              )
              
            }
          },
          error=> console.log(error)
        )
      }
      else{
        this.passwordError = "Passwords do not match";
      }
    }else{
      this.err = "Form Inavlid";
    }
  }
}
